import { DateTime } from 'luxon';

export class DownloadPsReceiptModalParams {
  /** @constructor */
  constructor(
    /** Data selezionata */
    public selectedDate: DateTime,
  ) {}
}
